import { Link } from "react-router-dom";
import { ShieldOff } from "lucide-react";
import { usePageSetup } from "../hooks/usePageSetup";

export function ForbiddenPage() {
  usePageSetup("Forbidden", null);

  return (
    <div className="mx-auto max-w-lg rounded-2xl bg-white p-10 text-center shadow-md">
      <ShieldOff size={40} className="mx-auto mb-4 text-gray-400" aria-hidden="true" />
      <h1 className="mb-2 text-2xl font-bold text-brand-navy focus:outline-none">Actuarial access required</h1>
      <p className="mb-6 text-gray-600">This screen is available to the Actuarial role. Your account is signed in as an Underwriter.</p>
      <Link to="/uw/recent" className="inline-flex min-h-[44px] items-center rounded-lg bg-brand-green px-4 py-2 text-sm font-medium text-white hover:bg-brand-green-hover focus:outline-none focus:ring-2 focus:ring-brand-green-50">
        Back to Recent Groups
      </Link>
    </div>
  );
}
